<mat-toolbar>
  <span>Configure Linked Record - {{ field?.FieldId }}</span>
</mat-toolbar>

@if (loaded) {
  <process-type-option [processType]="processType"
  (processingTypeChanged)="processTypeChanged($event)"></process-type-option>
}

@if (loaded && fieldsForLinkedModule) {
  <autofill-field-mapping
    [autoFillDefinition]="autoFillDefinition" [potentialMappingFields]="fieldsForLinkedModule" [stepFields]="currentStepFields"
    (mappingsChange)="mappingsChanged($event)">
  </autofill-field-mapping>
}

<mat-card class="action-buttons">
  <mat-card-actions align="end">
    <button mat-raised-button type="button" color="primary" (click)="goBack()">Close</button>
    <button mat-raised-button type="submit" color="accent" [disabled]="!saveEnabled" (click)="onSave()">Save</button>
  </mat-card-actions>
</mat-card>